/**
 * @prettier
 */
import {createSelector} from 'reselect';

import {getAbacusTests, getNavigation, getTranslations} from './store';
import {getIsMobile} from './system';
import getAvailabilityCalendar from './availabilityCalendar';
import {isInBucketData} from '../utils/abacusHelper';

const getNavLabels = createSelector(
    [getTranslations, getAvailabilityCalendar],
    (trans, availabilityCalendar) => {
        return {
            overview: trans.navOverview,
            amenities: trans.navAmenities,
            reviews: trans.navReviews,
            map: trans.navMap,
            availability: availabilityCalendar.shouldShowRates
                ? trans.navRatesAvailability
                : trans.navAvailability,
            photos: trans.navPhotos
        };
    }
);

const getNavTabsDesktop = createSelector(
    [getNavLabels, getAbacusTests],
    (navLabels, abacusTests) => [
        {id: 'overview', href: '#overview', label: navLabels.overview},
        {id: 'amenities', href: '#amenities', label: navLabels.amenities},
        {id: 'reviews', href: '#reviews', label: navLabels.reviews},
        {id: 'map', href: '#map', label: navLabels.map},
        ...(isInBucketData(abacusTests, 'ha_pdp_desktop_gallery', 1)
            ? [{id: 'photo-gallery', href: '#photo-gallery', label: navLabels.photos}]
            : []),
        {id: 'rates-availability', href: '#rates-availability', label: navLabels.availability}
    ]
);

// ha_pdp_mweb_sticky_nav
const getNavTabsMobile = createSelector(
    [getNavLabels],
    (navLabels) => [
        {id: 'overview', href: '#overview', label: navLabels.overview},
        {id: 'reviews', href: '#reviews', label: navLabels.reviews},
        {id: 'map', href: '#map', label: navLabels.map},
        {id: 'rates-availability', href: '#rates-availability', label: navLabels.availability},
        {id: 'amenities', href: '#amenities', label: navLabels.amenities}
    ]
);

const getNavTabs = createSelector(
    [getNavTabsDesktop, getNavTabsMobile, getIsMobile],
    (navTabsDesktop, navTabsMobile, isMobile) => {
        return isMobile ? navTabsMobile : navTabsDesktop;
    }
);

const getNavActiveTabIndex = createSelector(
    [getNavigation],
    (navigation) => navigation.navActiveTabIndex
);

const getNavData = createSelector(
    [getNavTabs, getNavActiveTabIndex, getIsMobile],
    (navTabs, activeIndex, isMobile) => ({navTabs, activeIndex, isMobile})
);

export default getNavData;
export {
    getNavLabels,
    getNavTabs,
    getNavTabsMobile,
    getNavTabsDesktop,
    getNavActiveTabIndex,
    getNavData
};
